<template>
  <div class="my-button">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MyButton',
  components: {},
  data() {
    return {}
  }
}
</script>
<style lang='stylus' >
.my-button
  display: inline-flex
  align-items: center
  justify-content: center
  white-space: nowrap
  font-size: 14px
  position: relative
  color: #fff
  padding: 0 8px
  box-sizing: border-box
  height: 36px
  min-width: 90px
  background-color: #fa671f
</style>
